module.exports = __webpack_public_path__ + "img/image 165.80a23208.png";